export default __webpack_public_path__ + "static/media/SE_logotype_lifeison_green.ae7cd230.svg";